<template>
  <div class="modal fade" id="editSubmissionModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">Edit Submission</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <label for="sub-text" class="col-form-label">Text:</label>
              <textarea class="form-control" id="editModalSubmissionText" :key="id" v-html="text" @input="text = $event.target.value"></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary px-3 rounded-pill" @click="hide()">Close</button>
          <button
            type="button"
            class="btn btn-primary px-3 rounded-pill"
            @click="saveChanges()"
          >Save Changes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditSubmissionPopup",

  data() {
    return {
      id: undefined,
      text: ""
    };
  },

  props: {
    submission: {
      id: {
        type: Number,
        required: true
      },
      text: {
        type: String,
        required: true
      }
    }
  },
    
  methods: {
    show() {
      $("#editSubmissionModal").modal("show");
      this.id = this.submission.id;
      this.text = this.submission.text;
    },
    hide() {
      $("#editSubmissionModal").modal("hide");
    },

    saveChanges() {
      let self = this;
      axios
        .post("/api/submissions/" + self.id + "/edit", {
          text: self.text
        })
        .then(function(response) {
          // this should be on a global event bus, then on the sub items listening to this calls a reload.
          self.$emit("submission-text-changed", self);
          self.hide();
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>